import { render, staticRenderFns } from "./tabsPane.vue?vue&type=template&id=2c0dc3c4&scoped=true&"
import script from "./tabsPane.vue?vue&type=script&lang=js&"
export * from "./tabsPane.vue?vue&type=script&lang=js&"
import style0 from "./tabsPane.vue?vue&type=style&index=0&id=2c0dc3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0dc3c4",
  null
  
)

component.options.__file = "tabsPane.vue"
export default component.exports